import { ReactNode, FC } from 'react';

interface HorizontalScrollProps {
    children: React.ReactNode;
}

const HorizontalScroll: React.FC<HorizontalScrollProps> = ({ children }) => {
    return (
        <div className="horizontal-scroll" style={{ display: 'flex', overflowX: 'scroll', whiteSpace: 'nowrap' }}>
            {children}
        </div>
    );
};

export default HorizontalScroll;

